import { render, staticRenderFns } from "./MiuDomand.vue?vue&type=template&id=5273b799&scoped=true"
import script from "./MiuDomand.vue?vue&type=script&lang=js"
export * from "./MiuDomand.vue?vue&type=script&lang=js"
import style0 from "./MiuDomand.vue?vue&type=style&index=0&id=5273b799&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5273b799",
  null
  
)

export default component.exports